export const BASE_URL = 'https://matthieuchollet.synology.me:2000/todos'
